import {Component, OnInit} from '@angular/core';

import { NetworkHelperService } from '../../../_services/network-helper.service';
import { FORMS, API, CODFUNC, PAGE, GENERALES } from '../../../_config/strings';
import { Router, ActivatedRoute } from '@angular/router';

import Swal from 'sweetalert2';
import { Usuario } from '../../../_model/Usuario';
import { Subject } from 'rxjs/Subject';
import { Cliente } from '../../../_model/Cliente';
import swal from 'sweetalert2';
import 'rxjs/add/operator/take';
import { IMyDpOptions, MyDatePicker, MyDatePickerModule } from 'mydatepicker';
import * as moment from 'moment';
import { ChatService } from '../../../_services/chat.service';

declare var $: any;

@Component({
  selector: 'app-listar-contratos-cliente',
  templateUrl: './listar-contratos-cliente.component.html',
  styleUrls: ['./listar-contratos-cliente.component.scss']
})

export class ListarContratosClienteComponent implements OnInit {

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  // deshabilitarBotonCrearCliente = true;
  FORMS: any;
  API: any;
  CODFUNC: any;
  PAGE: any;
  GENERALES: any;
  public usuario: Usuario = new Usuario();
  public cliente: Cliente = new Cliente();

  loginLoader = false;
  // Permisos en botón
  botonesPermisos = {
    crearContrato: false,
  };
  btnRegistrarContrato = false;
  // Array para crear reverse en dataTable
  clientesArrayReverse = [];

  contratosArray = [];
  // sinContrato: any;
  contratoCreado = '';
  // contratoURL = '';
  incremento = 1;
  estatus = [];
  ClienteId: any;
  estatusDeCliente = '';
  nombreObra = '';
  // Fecha
  fecha = Date;
  fechaDeInicio = '';
  duracionServicio = '';
  // fechaDeTermino = '';
  fechaEnDataPicker = '';
  nuevaFecha: any;

  permisosArray = [];

  bandera;

  // Calendario
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'yyyy/mm/dd',
    markCurrentDay: true,
    markCurrentMonth: true,
  };

  constructor(
    private network: NetworkHelperService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private chat: ChatService
  ) {
    this.FORMS = FORMS;
    this.API = API;
    this.CODFUNC = CODFUNC;
    this.GENERALES = GENERALES;
    this.PAGE = PAGE;
    this.usuario = JSON.parse(localStorage.getItem('usuario'));
    this.activatedRoute.params.take(1).subscribe((params: any) => {
      this.ClienteId = params['id'];
    });
  }

  ngOnInit() {
    this.dtOptions = {
      language: {
          url: '//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json'
      },
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
          const self = this;
          $('td', row).unbind('click');
          $('td', row).bind('click', () => {
              this.selectedRowClient(data);
          });
          return row;
      }
    };

    this.getContratos();
    this.getPermisos();
    this.inverse();
    this.getCliente();

    $('.letras').on('input', function (e) {
      if (!/^[ a-z0-9áéíóúüñ]*$/i.test(this.value)) {
          // [ a-z0-9áéíóúüñ]
          this.value = this.value.replace(/[^ a-z0-9áéíóúüñ]+/ig, '');
      }
    });

    $('.numeroContrato').on('input', function (e) {
      if (!/^[a-z0-9áéíóúüñ]*$/i.test(this.value)) {
          // [ a-z0-9áéíóúüñ]
          this.value = this.value.replace(/[^a-z0-9áéíóúüñ]+/ig, '');
      }
    });

  }

  getPermisos() {
    const peticion = {
        userId: this.usuario.userId,
        codigoFuncionalidad: 'CLIVER'
    };
    this.network.callSecureService(
      this.API.user.permisosFuncionalidad,
      'POST',
      peticion)
      .subscribe((response: any) => {
        this.permisosArray = response.Mensaje;
        this.mostrarBotones();
      }, err => {
        console.log(err);
        Swal('Error', this.GENERALES.algoOcurrio, 'error');
        this.mostrarBotones();
      }
    );
  }

  getCliente() {
    this.network.callSecureService(
      this.API.user.clientes + '/' + this.ClienteId,
      'GET',
      null ).subscribe((response: any) => {
        // console.log(response);
          if (response.Estatus === 206) {
            Swal('Oops', response.Mensaje, 'warning');
          } else {
            // Swal('Éxito', 'ruta correcta', 'success');
            this.estatusDeCliente = response.Mensaje.cliente.estatus.estatus;
            if (this.estatusDeCliente === 'AUTPREE' || this.estatusDeCliente === 'AUTCOMP' || this.estatusDeCliente === 'AUTREAB' || this.estatusDeCliente === 'AUTSPRO') {
              this.btnRegistrarContrato = false;
            } else {
              this.btnRegistrarContrato = true;
            }
          }
      }, err => {
        console.log(err);
        Swal('Error', this.GENERALES.algoOcurrio, 'error');
      }
    );
  }

  popUpRegistrarContrato() {
    Swal('Cuidado', 'No puedes registar un contrato porque el cliente aún no está pre-autorizado', 'info');
  }

  getContratos() {
    this.network.callSecureService(
      this.API.user.clientes + '/' + this.ClienteId + '/' + this.API.user.contratos,
      'GET',
      null)
      .subscribe((response: any) => {
        // console.log(response);
          if (response.Estatus === 200) {
          // this.estatusDeCliente = response.Mensaje.cliente.estatus;
          const responseMensajecontratos = response.Mensaje.contratos.reverse();
          let incremento = 1;
          this.contratosArray = [];
            for (const contrato of responseMensajecontratos) {
              const fecha1 = contrato.fechaInicio.split('T');
              this.contratosArray.push({
              // id: this.incremento ++,
              id: incremento++,
              noContrato: contrato.noContrato,
              fecha: fecha1[0],
              // fecha: contrato.fechaInicio,
              dias: contrato.dias,
              estatusColor: contrato.estatus.color,
              estatusNombre: contrato.estatus.nombre
            });
          }
        } else {
          swal('Ups', response.Mensaje, 'info');
        }
        this.dtTrigger.next();
      }, err => {
        console.log(err);
        Swal('Error', 'error del servidor, intentalo de nuevo o llama sistemas', 'error');
      }
    );
  }

  inverse() {
    this.clientesArrayReverse = this.contratosArray.reverse();
  }

  enviarContrato() {
    // Calendario
    this.fechaEnDataPicker = this.fechaDeInicio['formatted'];
    this.nuevaFecha = moment(this.fechaEnDataPicker['_i']).add(this.duracionServicio, 'days');
    // Objeto. propiedad de objeto(formatted)
    const formularioContrato: FormData = new FormData();
    this.loginLoader = true;

    formularioContrato.append('noContrato', this.contratoCreado);
    formularioContrato.append('fechaInicio', this.fechaEnDataPicker);
    formularioContrato.append('dias', this.duracionServicio);
    formularioContrato.append('obra', this.nombreObra);
    formularioContrato.append('fechaFin', this.nuevaFecha);
    // Al ser único elemento, utilizamos JQuery para poder agregar el documento al fromData.
    // utilizamos $('#(id<html>)'), cuando son varíos lo agregamos a la clase con (.). Cuando es un único elemento utilizamos #
    const fileUpload = $('#CONTRATO');
    formularioContrato.append(fileUpload[0].id, fileUpload[0].files[0]);

    this.network.callSecureService(
      this.API.user.clientes + '/' + this.ClienteId + '/' + this.API.user.contratos + '/' + this.API.user.crear,
      'POST',
      formularioContrato)
      .subscribe((response: any) => {
        // console.log(response);
        this.loginLoader = false;
        if ( response.Estatus !== 201 ) {
          Swal('Error', response.Mensaje, 'error');
          // Swal('Error', 'No se generó el contrato', 'warning');
          // this.router.navigate(['dashboard/verCliente/' + this.ClienteId + '/contratos/'+ this.contratoCreado+'/abastecimiento' ]);
        } else {
          Swal('Correcto', response.Mensaje.strings, 'success');
          /*
          let targets = response.Mensaje.notificacion;
          targets.forEach(e => {
            const target = e.target;
            this.sendMessage(target);
          });
          */
          // == Targets de notificación ==
          let targets = response.Mensaje.notificacion;
          targets.forEach(e => {
            const target = e.target;
            const id = e.id;
            let notificacionString =  'El usuario ' + this.usuario.userName + ' ha creado un nuevo contrato.';
            let url = 'verCliente/' + response.Mensaje.cliente;
            this.sendMessageTest(target, notificacionString, url, id);
          });
          // == Targets de notificación ==
        // El siguiente router.navigate es utilizado para recargar la página y mostrar de inmedito el nuevo contrato generado
        this.router.navigate(['dashboard/verCliente/' + this.ClienteId + '/contratos/' + this.contratoCreado + '/abastecimiento' ]);
        // this.getContratos()
        }
      }, err => {
        console.log(err);
        this.loginLoader = false;
        Swal('Error', 'Algo ocurrió', 'error');
      }
    );
  }

  selectedRowClient (info: any) {
    // console.log(info);
    const permisoVerCliente = this.permisosArray.find( permiso => permiso === 'CONVER' );
    if (permisoVerCliente) {
        // En el siguiente router.navigate es utilizado para dirigir a la página y mostrar los mivimientos disponibles con dicho contrato.
        // En router.navigate se utiliza info[1], porque necesitamos el folio del contrato que ya se muestra en el datatable.
        this.router.navigate(['dashboard/verCliente', this.ClienteId, 'contratos', info[1], 'abastecimiento']);
    } else {
        Swal('Error', this.GENERALES.noTienePermisos, 'error');
    }
  }

  mostrarBotones () {
    const permisoCrearCliente = this.permisosArray.find( permiso => permiso === 'CONCREA' );
    if (permisoCrearCliente) {
      this.botonesPermisos.crearContrato = true;
      document.getElementById('botonCrearCliente').style.opacity = '1';
    } else {
        // Swal('Error', this.GENERALES.noTienePermisos, 'error');
        // this.router.navigate(['/dashboard']);
    }
  }

  sendMessage(target) {
    let mensaje = {
      mensaje: 'El usuario ' + this.usuario.userName + ' ha creado un nuevo contrato',
      usuario: this.usuario.userName,
      target: target,
      tipo: 'notificacion'
    };
    this.chat.sendMsg(mensaje);
  }

  sendMessageTest(target, notificacionString, url, id) {
    let mensaje = {
      mensaje: notificacionString,
      usuario: this.usuario.userName,
      target: target,
      tipo: 'notificacion',
      url: url,
      id: id
    };
    this.chat.sendMsg(mensaje);
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/cliente/listar-contratos-cliente/listar-contratos-cliente.component.ts